import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Tab from './parts/tab.js';
import { TabListContext } from './parts/tab-list-context.js';
import { withScrollArrows } from './parts/with-scroll-arrows.js';
import { useIndicator } from './parts/use-indicator.js';
import styles from './parts/tab-list.p.module.css.js';
var STYLES_SIZES = {
  m: styles.sizeM,
  l: styles.sizeL
};

var InnerTabList = function InnerTabList(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      _ref$sparse = _ref.sparse,
      sparse = _ref$sparse === void 0 ? false : _ref$sparse,
      className = _ref.className,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'classic' : _ref$mode,
      _ref$short = _ref.short,
      short = _ref$short === void 0 ? false : _ref$short,
      theme = _ref.theme,
      value = _ref.value,
      onChange = _ref.onChange,
      children = _ref.children,
      selectedId = _ref.selectedId,
      activeNodeRef = _ref.activeNodeRef,
      containerRef = _ref.containerRef,
      e2eId = _ref['data-e2e'];
  var indicator = useIndicator({
    activeNodeRef: activeNodeRef,
    containerRef: containerRef,
    triggers: [value, children]
  });
  return /*#__PURE__*/React.createElement(TabListContext.Provider, {
    value: {
      short: short,
      onChange: onChange,
      selectedId: selectedId
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.tabsContainer, styles[theme], styles[mode], STYLES_SIZES[size], sparse ? styles.innerOffsetL : styles.innerOffsetM, className),
    "data-e2e": e2eId ? "".concat(e2eId, "__tabs-container") : null,
    "data-test": 'tab-list',
    ref: containerRef
  }, children, /*#__PURE__*/React.createElement("span", {
    style: indicator,
    className: styles.indicator
  })));
};

InnerTabList.displayName = 'TabList';
var TabList = withScrollArrows(InnerTabList, Tab); // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
// @ts-ignore

TabList.propTypes = {
  size: PropTypes.oneOf(['m', 'l']),
  sparse: PropTypes.bool,
  theme: PropTypes.oneOf(['light', 'dark']),
  className: PropTypes.string,
  mode: PropTypes.oneOf(['classic', 'rock']),
  short: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.symbol, PropTypes.object]),
  onChange: PropTypes.func,
  compareValues: PropTypes.func,
  'data-e2e': PropTypes.string
};
export { TabList, TabList as default };
